const ROUTES = {
  PROFILE: '/profile',
  PROJECTS: '/projects',
  SKILLS: '/skills',
  CONTACT: '/contact',
  SETTINGS: '/settings',
  DEFAULT: '/',
};

export default ROUTES;
